import { render, staticRenderFns } from "./EvidenceVideo.vue?vue&type=template&id=28ead5a3&scoped=true&name=evidencevideo&"
import script from "./EvidenceVideo.vue?vue&type=script&lang=js&"
export * from "./EvidenceVideo.vue?vue&type=script&lang=js&"
import style0 from "./EvidenceVideo.vue?vue&type=style&index=0&id=28ead5a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ead5a3",
  null
  
)

export default component.exports